import { render, staticRenderFns } from "./DatatablePagination.vue?vue&type=template&id=3d711618&scoped=true&"
import script from "./DatatablePagination.vue?vue&type=script&lang=js&"
export * from "./DatatablePagination.vue?vue&type=script&lang=js&"
import style0 from "./DatatablePagination.vue?vue&type=style&index=0&id=3d711618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d711618",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
